import { render, staticRenderFns } from "./StockInventoryTasksWarning.vue?vue&type=template&id=27b4580a&scoped=true&"
import script from "./StockInventoryTasksWarning.vue?vue&type=script&lang=js&"
export * from "./StockInventoryTasksWarning.vue?vue&type=script&lang=js&"
import style0 from "./StockInventoryTasksWarning.vue?vue&type=style&index=0&id=27b4580a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b4580a",
  null
  
)

export default component.exports
import {QBanner,QTable,QTh,QTr,QTd,QBtn,QTooltip} from 'quasar'
component.options.components = Object.assign({QBanner,QTable,QTh,QTr,QTd,QBtn,QTooltip}, component.options.components || {})
